import React, { useState } from "react";
import { ChatText, CheckCircle, Warning, PaperPlaneTilt } from '@phosphor-icons/react';

const PublicProject = ({ project, submit_via_public_project_project_path, root_path }) => {
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const cardColor = `bg-${project.card_color}`;
  const buttonColor = `btn-${project.button_color}`;
  const buttonText = project.button_text || "Submit Message";
  const textAreaPlaceholder = project.text_area_placeholder || "Type your message here...";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await fetch(submit_via_public_project_project_path.replace(":id", project.public_project_token), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
        },
        body: JSON.stringify({ content: message })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to submit message');
      }

      setSuccess(true);
      setMessage("");
      setError(null);
      Turbo.visit(root_path);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="px-4 py-8 max-w-3xl mx-auto">
      <div className={`card shadow-xl ${cardColor}`}>
        <div className="card-body">
          <h1 className="card-title text-2xl flex items-center gap-2">
            <ChatText className="h-6 w-6" />
            {project.name}
          </h1>
          
          {success && (
            <div className="alert alert-success">
              <CheckCircle className="h-6 w-6" />
              <span>Your message has been submitted successfully!</span>
            </div>
          )}

          {error && (
            <div className="alert alert-error">
              <Warning className="h-6 w-6" />
              <span>{error}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="form-control w-full">
              <textarea 
                className="textarea textarea-bordered h-64 w-full textarea-xl" 
                placeholder={textAreaPlaceholder}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                disabled={isSubmitting}
                required
              ></textarea>
            </div>

            <div className="form-control mt-6">
              <button 
                type="submit" 
                className={`btn ${buttonColor} btn-xs ${isSubmitting ? 'loading' : ''}`}
                disabled={isSubmitting || !message.trim()}
              >
                {isSubmitting ? (
                  <span className="loading loading-spinner loading-xs"></span>
                ) : (
                  <PaperPlaneTilt className="h-3 w-3 mr-1" />
                )}
                {isSubmitting ? 'Submitting...' : buttonText}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PublicProject;
